import React from 'react'
import styled from 'styled-components'
import useUserBookRecommendations from './useUserBookRecommendations'
import UserBookRecommendationListRow from './UserBookRecommendationListRow'
import UserBookRecommendationListRowLoading from './UserBookRecommendationListRowLoading'
import RowSpacer from '../../../../common/styles/RowSpacer'
import { BooksitoutServer } from '../../../../config/BooksitoutServer'
import useLoginStore from '../../../login/useLoginStore'
import BooksitoutIcon from '../../../../config/BooksitoutIcon'
import NoContent from '../../../../common/NoContent'

const UserBookRecommendationSection = () => {
	const isLoggedIn = useLoginStore((state) => state.isLoggedIn())
	const [isLoading, recommendations, setRecommendations, paging] = useUserBookRecommendations(5)

	const handleLikeToggle = (id: number) => {
		if (!isLoggedIn) return

		const target = recommendations.find((r) => r.id === id)
		if (!target) return

		const willLike = !target.isLiked

		setRecommendations((prev) =>
			prev.map((r) => (r.id === id ? { ...r, isLiked: willLike, likeCount: r.likeCount + (willLike ? 1 : -1) } : r))
		)

		const revert = () =>
			setRecommendations((prev) =>
				prev.map((r) => (r.id === id ? { ...r, isLiked: !willLike, likeCount: r.likeCount + (willLike ? -1 : 1) } : r))
			)

		if (willLike) {
			BooksitoutServer.post(`/v1/book-user-recommendations/${id}/like`).catch(() => revert())
		} else {
			BooksitoutServer.delete(`/v1/book-user-recommendations/${id}/like`).catch(() => revert())
		}
	}

	if (isLoading) {
		return (
			<>
				<SectionHeader>
					<SectionTitle>사용자들의 책 추천</SectionTitle>
				</SectionHeader>
				<RowSpacer size={5} />
				{Array.from({ length: 3 }).map((_, index) => (
					<React.Fragment key={index}>
						<UserBookRecommendationListRowLoading colorType={'card'} />
						<RowSpacer size={5} />
					</React.Fragment>
				))}
			</>
		)
	}

	if (recommendations.length === 0) {
		return (
			<>
				<SectionHeader>
					<SectionTitle>사용자들의 책 추천</SectionTitle>
				</SectionHeader>
				<NoContent message={'아직 추가된 책 추천이 없어요'} />
			</>
		)
	}

	return (
		<>
			<SectionHeader>
				<SectionTitle>사용자들의 책 추천</SectionTitle>
			</SectionHeader>

			<RowSpacer size={5} />

			{recommendations.map((rec) => (
				<React.Fragment key={rec.id}>
					<UserBookRecommendationListRow recommendation={rec} colorType={'card'} onLikeToggle={handleLikeToggle} />
					<RowSpacer size={5} />
				</React.Fragment>
			))}

			{paging.hasMore && (
				<MoreButton onClick={paging.fetchNext}>
					<BooksitoutIcon.ArrowDown color="#66BB6B" size={14} />
					<span>더 보기</span>
				</MoreButton>
			)}
		</>
	)
}

const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

const SectionTitle = styled.h4`
	font-weight: bold;
	color: var(--text-color);
	margin: 0 0 15px 0;
`

const MoreButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	width: 100%;
	padding: 12px;
	border: none;
	border-radius: 8px;
	background-color: var(--card-bg-color);
	color: #66bb6b;
	font-size: 0.9rem;
	font-weight: bold;
	cursor: pointer;

	&:hover {
		opacity: 0.8;
	}
`

export default UserBookRecommendationSection
